import { GraphQLObjectType, GraphQLString } from 'graphql';
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import pickBy from 'lodash/pickBy';
import pick from 'lodash/pick';
import negate from 'lodash/negate';
import AMAudienceDiversityType from '../AMAudienceDiversityType/type';
import AMAudienceCountyType from '../AMAudienceCounty/type';
import AMAudienceZipCodeType from '../AMAudienceZipCode/type';

export function populatedAudienceFields(audience) {
  return pickBy(pick(audience, ['diversity', 'county', 'state', 'zipCode', 'sector']), negate(isNil));
}
export function isAudienceEqual(audience1, audience2) {
  return isEqual(populatedAudienceFields(audience1), populatedAudienceFields(audience2));
}

const AMAudienceType = new GraphQLObjectType({
  // note: name is not using 'AM' prefix due to 'historical' reasons
  name: 'Audience',
  description: 'ActiveMatch Subscription Audience Settings',
  fields: () => ({
    diversity: {
      type: AMAudienceDiversityType,
      description: 'ActiveMatch Audience Diversity',
    },
    county: {
      type: AMAudienceCountyType,
      description: 'ActiveMatch Audience County Location',
    },
    state: {
      type: GraphQLString,
      description: 'ActiveMatch Audience State Location',
    },
    zipCode: {
      type: AMAudienceZipCodeType,
      description: 'ActiveMatch Audience ZipCode Location',
    },
    sector: {
      type: GraphQLString,
      description: 'ActiveMatch Audience Sector Location',
    },
  }),
});

export default AMAudienceType;
